/*
  A simple class to map keys from one javascript object to another. Handy for logging
  javascript objects to sumo... which is why it's named sumo-mapper...

  ...yep.
*/

var _ = require('underscore');

function __uppercaseString(str) {
  var words = str.split(' ');
  return words.map(function(word) {
    // word!
    return (word.substr(0,1).toUpperCase() + word.substr(1));
  }).join(' ');
}

function SumoMapper(mapping) {
  this.mappings = mapping;
  this.attributes = {};
}

SumoMapper.prototype.set = function(key, val) {
  var parent = this;
  if(_.isObject(key)) {
    _.each(_.keys(key), function(prop) {
      if(typeof(key[prop]) !== 'function') {
        parent.set(prop, key[prop]);
      }
    });
    return;
  }

  // on the off chance you get a sumo mapper
  // instance, don't add it to tha map
  if(val && val.constructor === SumoMapper) {
    return;
  }

  var mappedKey = this.mappings[key] || __uppercaseString(key);
  this.attributes[mappedKey] = val;
};

SumoMapper.prototype.toJSON = function() {
  return this.attributes;
};

SumoMapper.prototype.toLog = function() {
  var log = [];
  var attrs = this.attributes;
  _.each(_.keys(attrs), function(prop) {
    var val = attrs[prop] || '';
    log.push(prop + '=' + val.toString());
  });

  return log.join(' ');
}

module.exports = SumoMapper;
